import { render, staticRenderFns } from "./SmplPush9006.vue?vue&type=template&id=3669954c&scoped=true&"
import script from "./SmplPush9006.vue?vue&type=script&lang=js&"
export * from "./SmplPush9006.vue?vue&type=script&lang=js&"
import style0 from "./SmplPush9006.vue?vue&type=style&index=0&id=3669954c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3669954c",
  null
  
)

export default component.exports